<template>
  <div :class="['bandcamp-album-player']">
    <iframe seamless :src="makeBandCampPlayerUrl(album.id)" frameborder="0" :style="{height: $config.bandCampPlayer.height}" />
  </div>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'AlbumPlayer',
  mixins: [
    methods
  ],
  props: {
    album: {
      type: Object,
      required: true
    }
  }
}
</script>
<style>
.bandcamp-album-player iframe
{
  border: 0;
  width: 100%;
  display: block;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/album-player.vue